import * as React from 'react';
import { useCallback } from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import videoPlayerImage from '../../assets/images/videoPlayer.png';

export interface IPostGridProps {
    propObject: {
        itemsLength: number,
        heights: number[],
        remainingPhotosFontSize?: number,
        getDataByOnClick: Function,
        rootData: any,
        gapX?: number,
        gapY?: number,
        radius?: number,
        images: {
            id?: number,
            source: string,
            isVideoPlayOnPost: boolean,
            isVideo?: boolean,
            videoSrc: string,
        }[],
    }
}

export function PostGrid(props: IPostGridProps) {
    const { itemsLength, heights = [260, 220], images, gapX = 0, gapY = 0, getDataByOnClick, rootData, radius = 0, remainingPhotosFontSize = 24 } = props.propObject;


    // 5 = 260, 220
    // 4 = 260, 260
    // 3 = 320, 250
    // 2 = 400
    // 1 = 300
    // console.log(images);



    const setVideoPlayer = useCallback((src: any) => {

        const plyrProps: any = {
            source: {
                type: 'video',
                title: 'Example title',
                sources: [
                    {
                        src: src,
                        type: 'video/mp4',
                        size: 720,
                    },
                ],
            },
            options: {
                enabled: true,
                debug: false,
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'fullscreen'],
                loadSprite: true,
                tooltips: { controls: false, seek: true },
                ratio: '16:9',
                ads: { enabled: false, publisherId: '', tagUrl: '' },
            },
        }

        return (
            plyrProps
        )
    }, [])






    return (
        <div className={``}>


            {itemsLength > 5 &&
                <div className={`flex flex-col`}>
                    <div className={`grid grid-cols-2 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[0]}px`, columnGap: `${gapX}px`, marginBottom: `${gapY}px` }}>
                        <div className={`h-full w-full cursor-pointer`}
                            onClick={() => getDataByOnClick(images[0], rootData)}
                            style={{
                                background: `url(${images[0].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[1], rootData)}
                            style={{
                                background: `url(${images[1].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>

                    <div className={`grid grid-cols-3 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[1]}px`, columnGap: `${gapX}px`, }}>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[2], rootData)}
                            style={{
                                background: `url(${images[2].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[3], rootData)}
                            style={{
                                background: `url(${images[3].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer relative"
                            onClick={() => getDataByOnClick(images[4], rootData)}
                            style={{
                                background: `url(${images[4].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                            <div className="bg-[#000000] opacity-[0.83] absolute w-full h-full flex justify-center items-center"
                                style={{ borderRadius: `${radius}px`, }}>
                                <p className="text-white select-none"
                                    style={{ fontSize: `${remainingPhotosFontSize}px` }}>{itemsLength - 5}+</p>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {itemsLength === 5 &&
                <div className={`flex flex-col`}>
                    <div className={`grid grid-cols-2 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[0]}px`, columnGap: `${gapX}px`, marginBottom: `${gapY}px` }}>
                        <div className={`h-full w-full cursor-pointer`}
                            onClick={() => getDataByOnClick(images[0], rootData)}
                            style={{
                                background: `url(${images[0].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[1], rootData)}
                            style={{
                                background: `url(${images[1].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>

                    <div className={`grid grid-cols-3 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[1]}px`, columnGap: `${gapX}px`, }}>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[2], rootData)}
                            style={{
                                background: `url(${images[2].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[3], rootData)}
                            style={{
                                background: `url(${images[3].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer relative"
                            onClick={() => getDataByOnClick(images[4], rootData)}
                            style={{
                                background: `url(${images[4].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>
                </div>
            }




            {itemsLength === 4 &&
                <div className={`flex flex-col`}>
                    <div className={`grid grid-cols-2 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[0]}px`, columnGap: `${gapX}px`, marginBottom: `${gapY}px` }}>
                        <div className={`h-full w-full cursor-pointer`}
                            onClick={() => getDataByOnClick(images[0], rootData)}
                            style={{
                                background: `url(${images[0].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>
                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[1], rootData)}
                            style={{
                                background: `url(${images[1].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>

                    <div className={`grid grid-cols-2 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[1]}px`, columnGap: `${gapX}px`, }}>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[2], rootData)}
                            style={{
                                background: `url(${images[2].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[3], rootData)}
                            style={{
                                background: `url(${images[3].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>
                </div>
            }

            {itemsLength === 3 &&
                <div className={`flex flex-col`}>
                    <div className={`grid grid-cols-1 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[0]}px`, columnGap: `${gapX}px`, marginBottom: `${gapY}px` }}>
                        <div className={`h-full w-full cursor-pointer`}
                            onClick={() => getDataByOnClick(images[0], rootData)}
                            style={{
                                background: `url(${images[0].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>

                    <div className={`grid grid-cols-2 divide-x divide-[#ffffff80] overflow-hidden`}
                        style={{ height: `${heights[1]}px`, columnGap: `${gapX}px`, }}>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[1], rootData)}
                            style={{
                                background: `url(${images[1].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                        <div className="h-full w-full cursor-pointer"
                            onClick={() => getDataByOnClick(images[2], rootData)}
                            style={{
                                background: `url(${images[2].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    </div>
                </div>
            }


            {itemsLength === 2 &&
                <div className={`grid grid-cols-2 divide-x divide-[#ffffff80] overflow-hidden`}
                    style={{ height: `${heights[0]}px`, columnGap: `${gapX}px`, marginBottom: `${gapY}px` }}>
                    <div className={`h-full w-full cursor-pointer`}
                        onClick={() => getDataByOnClick(images[0], rootData)}
                        style={{
                            background: `url(${images[0].source})`, backgroundAttachment: '',
                            borderRadius: `${radius}px`,
                            backgroundSize: 'cover', backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}>

                    </div>

                    <div className="h-full w-full cursor-pointer"
                        onClick={() => getDataByOnClick(images[1], rootData)}
                        style={{
                            background: `url(${images[1].source})`, backgroundAttachment: '',
                            borderRadius: `${radius}px`,
                            backgroundSize: 'cover', backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}>

                    </div>
                </div>
            }

            {itemsLength === 1 &&
                <div className={`grid grid-cols-1 divide-x divide-[#ffffff80] overflow-visible`}
                    style={{ height: images[0].isVideoPlayOnPost ? 'auto' : `${heights[0]}px`, columnGap: `${gapX}px`, marginBottom: `${gapY}px` }}>

                    {images[0].isVideo
                        ? images[0].isVideoPlayOnPost
                            ? <div className="">
                                <VideoPlayer plyrProps={setVideoPlayer(images[0].videoSrc)} />
                            </div>

                            : <div className={`w-full h-full cursor-pointer`}
                                onClick={() => getDataByOnClick(images[0], rootData)}
                                style={{
                                    backgroundImage: `url(${images[0].source})`, backgroundAttachment: '',
                                    borderRadius: `${radius}px`,
                                    backgroundSize: 'cover', backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}>
                            </div>

                        : <div className={`h-full w-full cursor-pointer`}
                            onClick={() => getDataByOnClick(images[0], rootData)}
                            style={{
                                background: `url(${images[0].source})`, backgroundAttachment: '',
                                borderRadius: `${radius}px`,
                                backgroundSize: 'cover', backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}>

                        </div>
                    }


                </div>}





        </div>
    );
}
